<template>
  <div  v-if="likeList" class="likeList">
		<ul>
			<li v-for="item in datas" v-bind:key="item.id">
				<img class="portrait" v-if="item.avatar" :src="item.avatar" />
				<img @click="dianzan" v-if="!item.avatar" src="@/assets/applyuser/3.png" />
			</li>
		</ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from "../event-bus.js";
export default {
  name: 'likeList',
  data(){
	  return {

	  }
  },
  props:['likeList'],
  computed: {
  		... mapState([
  			  'liked',
			  'userInfo',
			  'uid'
		]),
		datas(){
			var _d = [{ avatar : '',id : '1'},
			{ avatar : '',id : '2'},
			{ avatar : '',id : '3'},
			{ avatar : '',id : '4'},
			{ avatar : '',id : '5'}];

			_d.splice(0,this.likeList.length,...this.likeList);

			return _d;
		}
  },
  created(){
	  console.log('dianzan',this.$route.params.id)
	  //alert(`/campaigns-b/try/index.php&_c=callback&_a=oauth&page=show&id=${this.$route.params.id}`)
	  EventBus.$on("dianzan", ({}) => {
		  if(this.$store.state.authed === true){
		  	 this.dianzan();
		  }else{
        // 判断如果不是微信环境
        if (!this.$tool.isWechatBrowser()) return window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=APPID';
		  	window.location.href = `/campaigns-b/try/index.php?_c=callback&_a=oauth&page=show&id=${this.$route.params.id}`;
		  	return;
		  }

	  });

  },
  methods: {
	  dianzan() {
		 if(this.liked === true || this.uid == this.userInfo.id)return;
		 this.$store.commit('setState',{
		 	liked : true
		 });

		 var storage=window.localStorage;
		 var likedMap = JSON.parse(storage.getItem('likedMap')||'{}' );
			 likedMap['liked'+this.$store.state.aid] = true;
			 storage.setItem('likedMap',JSON.stringify(likedMap));

	  	this.axios
	  		 .post('/campaigns-b/try/index.php?_c=show&_a=reply&aid='+this.$store.state.aid)
	  		 .then((response) => {
	  			 var d = response.data.data;
	  				 if(response.data.code == 500){
	  					 //alert('已经点过赞喽');
						// return;
	  				 }

	  				if(response.data.code == 200){
						EventBus.$emit("updateList", ({}) => {});
						 this.$store.commit('setShowAlert',true);
						 setTimeout(() => {
							 this.$store.commit('setShowAlert',false)
						 },1000)
	  				}

	  		 }).catch(function (error) { // 请求失败处理
	  	  console.log(error);
	  	});
	  	//this.$store.commit('setShowAlert',true);
	  }

  },
  components: {

  }
}
</script>

<style>

	.likeList{
		margin: 4vw auto 5.5vw;
		width: 64.8vw;
	}

	.likeList ul{
		 display: flex;
		 flex-direction:row;
		 align-items: center;
		 justify-content: center;
	}

	.likeList li{
		 margin-right:5vw;
	}

	.likeList li:last-child{
		 margin-right: 0px;
	}

	.likeList img{
		width: .8rem;
	}
</style>
